import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChatCircleText } from "@phosphor-icons/react";
import api from "@/lib/api";

// Navbar Messages icon with an unread-conversation badge (polls every 20s).
export default function MessagesBell() {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/dm/unread-count").then((r) => { if (alive) setCount(r.data.count || 0); }).catch(() => {});
    load();
    const t = setInterval(load, 20000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  return (
    <Link to="/messages" className="relative grid h-9 w-9 place-items-center rounded-full hover:bg-accent/60 transition-colors" data-testid="nav-messages" aria-label="Messages">
      <ChatCircleText size={20} />
      {count > 0 && (
        <span className="absolute -right-0.5 -top-0.5 grid min-w-[16px] place-items-center rounded-full bg-primary px-1 text-[10px] font-semibold leading-4 text-primary-foreground" data-testid="nav-messages-badge">
          {count > 9 ? "9+" : count}
        </span>
      )}
    </Link>
  );
}
